import React, { FC } from 'react'
import { Route, Switch } from 'react-router'

import { routes } from '../../constants/routes'
import { Finance } from '.'
import { TransactionDetails } from '../UserProfile/UserTransactions/TransactionDetails'

export const FinanceRoutes: FC = () => {
  return (
    <Switch>
      <Route path={routes.FINANCE_TRANSACTION_DETAILS} component={TransactionDetails} />
      <Route path={routes.FINANCE_TABS} component={Finance} />
    </Switch>
  )
}
